
import { ActionReducerMap } from '@ngrx/store';
import { State as MemberState, memberReducer } from './members.reducers';
import { State as corporateSate, corporateReducer } from './corporates.reducers';
import { State as advisorState, advisorReducer } from './advisors.reducers';
import { State as languageState, languageReducer } from './language.reducers';
import { State as brokerConfigState, brokerConfigReducer } from './brokerConfig.reducers';
import { State as corporateSignupConfigState, corporateSignupConfigReducer } from './corporateSignupConfig.reducers';
import { State as brokerFormConfigState, brokerFormConfigReducer } from './brokerFormReducers.reducers';
import { State as formConfig2State, formConfig2Reducer } from './formConfig2.reducers';
import { State as memberFormConfigState, memberFormConfigReducer } from './memberFormConfig.reducers';

export interface AppState {
  memberData: MemberState;
  corporateData: corporateSate;
  advisorData: advisorState;
  languageData: languageState;
  brokerConfigData: brokerConfigState;
  corporateSignupConfigData: corporateSignupConfigState;
  brokerFormConfigData: brokerFormConfigState;
  formConfig2Data: formConfig2State;
  memberFormConfigData: memberFormConfigState;
}

export const reducers: ActionReducerMap<AppState> = {
  memberData: memberReducer,
  corporateData: corporateReducer,
  advisorData: advisorReducer,
  languageData: languageReducer,
  brokerConfigData: brokerConfigReducer,
  corporateSignupConfigData: corporateSignupConfigReducer,
  brokerFormConfigData: brokerFormConfigReducer,
  formConfig2Data: formConfig2Reducer,
  memberFormConfigData: memberFormConfigReducer,
};
